import DataFetch from '../../Utility/data-fetch'
import Storage from '../../Utility/site-cookies'

const call = (baseUrl) => {
    return {
        storage: window.localStorage,

        interlinearMode: false,

        open: false,
        translationBooks: [],
        currentTranslation: {},
        currentTranslationCode: '',
        translations: [],
        recentTranslations: [],
        loading: false,
        showRecent: false,

        async start(isInterlinear, startingTranslation) {
            this.interlinearMode = isInterlinear

            let ver = isInterlinear ? 'kjv' : 'niv'

            if (isInterlinear) {
                ver = Storage().readPref("interlinear-translation", startingTranslation || 'kjv')
            } else {
                ver = Storage().readPref("translation", 'niv')
            }

            await this.getAllTranslation({code: ver})
        },

        async getTranslationBooks(biblePassage) {
            // Already in memory? Return.
            if (this.translations && this.translations.length > 0) {
                return;
            }

            this.loading = true;

            await DataFetch.get(baseUrl, {
                params: {
                    translationCode: biblePassage.TranslationCode,
                    bookSlug: biblePassage.BookSlug,
                    chapterId: biblePassage.ChapterId,
                    startVerse: biblePassage.StartVerse,
                    endVerse: biblePassage.EndVerse,
                    isChapter: biblePassage.IsChapter,
                },
            })
                .then(response => {
                    this.currentTranslationCode = response.data.currentTranslationCode;
                    this.translations = response.data.translations;

                    // Load Recent.
                    try {
                        this.recentTranslations = JSON.parse(this.storage.getItem("recent-translations")) || [];                        
                    } catch (err) {
                        console.log("BST:TRSELECT - Invalid JSON - " + err);
                    }

                    if (this.recentTranslations && this.recentTranslations.length > 0) {
                        this.recentTranslations.map(translation => {
                            const matchTranslation = this.translations.find(t => t.code === translation.code);

                            if (matchTranslation) {
                                translation.link = matchTranslation.link;
                            } else {
                                translation.hideme = true;
                            }
                        });

                        this.showRecent = true;
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                });
        },

        async getPassagesTranslations(currentTranslationCode, title) {
            // Already in memory? Return.
            if (this.translations && this.translations.length > 0) {
                return;
            }

            this.loading = true;

            await DataFetch.get(baseUrl, {
                params: {
                    translationCode: currentTranslationCode,
                    passagesTitle: title,
                },
            })
                .then(response => {
                    this.currentTranslationCode = response.data.currentTranslationCode;
                    this.translations = response.data.translations;
                    this.currentTranslation = this.translations.find(s => s.code === this.currentTranslationCode)

                    // Load Recent.
                    try {
                        this.recentTranslations = JSON.parse(this.storage.getItem("recent-translations")) || [];
                    } catch (err) {
                        console.log("BST:TRSELECT - Invalid JSON - " + err);
                    }

                    if (this.recentTranslations && this.recentTranslations.length > 0) {
                        this.recentTranslations.map(translation => {
                            const matchTranslation = this.translations.find(t => t.code === translation.code);

                            if (matchTranslation) {
                                translation.link = matchTranslation.link;
                            } else {
                                translation.hideme = true;
                            }
                        });

                        this.showRecent = true;
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                });
        },

        pushRecent(translation) {
            if (this.recentTranslations.some(rt => rt.code === translation.code)) {
                const newTopIndex = this.recentTranslations.findIndex(rt => rt.code === translation.code);

                // Swap
                let oldTop = this.recentTranslations[0];
                this.recentTranslations[0] = this.recentTranslations[newTopIndex];
                this.recentTranslations[newTopIndex] = oldTop;
            } else {
                this.recentTranslations.unshift(translation);

                if (this.recentTranslations.length > 5) {
                    this.recentTranslations.pop();
                }
            }

            Storage().write("recent-translations", JSON.stringify(this.recentTranslations));            
            Storage().write('bible-sidebar-selected-tab', 1); // Reset sidebar tab when changing versions.

            this.currentTranslation = translation
        },

        async gotoPassageForTranslation(passageUrl, passageTitle, translationCode) {
            window.location.href = `${passageUrl}?q=${passageTitle.replace(" ", "+").toLowerCase()}&t=${translationCode}`
        },

        async getAllTranslation(translation) {
            // Already in memory? Return.
            if (this.translations && this.translations.length > 0) {
                return;
            }

            this.loading = true;
            this.translationBooks = {};

            await DataFetch.get(baseUrl, {
                params: {
                    translationCode: !translation || !translation.code ? "niv" : translation.code
                },
            })
                .then(response => {
                    this.currentTranslationCode = translation.code;
                    this.translations = response.data.translations;
                    this.currentTranslation = this.translations.find(s => s.code === this.currentTranslationCode)

                    // Load Recent.
                    try {
                        this.recentTranslations = JSON.parse(this.storage.getItem("recent-translations")) || [];
                    } catch (err) {
                        console.log("BST:TRSELECT - Invalid JSON - " + err);
                    }

                    if (this.recentTranslations && this.recentTranslations.length > 0) {
                        this.recentTranslations.map(translation => {
                            const matchTranslation = this.translations.find(t => t.code === translation.code);

                            if (matchTranslation) {
                                translation.link = matchTranslation.link;
                            } else {
                                translation.hideme = true;
                            }
                        });

                        this.showRecent = true;
                    }

                    this.loading = false;
                })
                .catch(err => {
                    console.log(err.response);
                    this.loading = false;
                });
        },

        async searchChangeTranslation(translation) {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            params.set('t', translation.code);
            window.location.href = `${url.origin}${url.pathname}?${params.toString()}`
        }
    };
};

export default call;